import { api } from './api';

export interface SocialLink {
  id?: number;
  platform: string;
  label?: string;
  url: string;
  display_order?: number;
  created_at?: string;
  updated_at?: string;
}

export interface Collaboration {
  id: number;
  name: string;
  description?: string | null;
  logo?: string | null;
  url?: string | null;
}

export interface ProfileResponse {
  success: boolean;
  profile: {
    id: number;
    name: string;
    profile_url: string;
    collaborations: Collaboration[];
    social_links: SocialLink[];
  };
}

export interface SocialLinksResponse {
  success: boolean;
  social_links: SocialLink[];
  count: number;
}

export const fetchMyProfile = () =>
  api.get<ProfileResponse>('/profiles/me');

export const fetchSocialLinks = () =>
  api.get<SocialLinksResponse>('/social-links');


